"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var clsx_1 = __importDefault(require("clsx"));
var styled_components_1 = __importDefault(require("styled-components"));
var BackDrop_1 = __importDefault(require("./BackDrop"));
var reactHelpers_1 = require("../utils/reactHelpers");
var ModalSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: ", ";\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  width: ", ";\n  padding: ", ";\n\n  box-sizing: border-box;\n  border-radius: ", ";\n\n  background-color: ", ";\n\n  /* <= 767px */\n  @media (max-width: ", ") {\n    width: ", ";\n    padding: ", ";\n  }\n"], ["\n  z-index: ", ";\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n\n  width: ", ";\n  padding: ", ";\n\n  box-sizing: border-box;\n  border-radius: ", ";\n\n  background-color: ", ";\n\n  /* <= 767px */\n  @media (max-width: ",
    ") {\n    width: ", ";\n    padding: ", ";\n  }\n"])), function (p) { return p.theme.zIndex.topLayer; }, function (p) { return p.theme.SizeWidthModalDesktop; }, function (p) { return p.theme.SizePaddingModalDesktop; }, function (p) { return p.theme.SizeBorderRadiusModalBase; }, function (p) { return p.theme.ColorBackgroundModalBase; }, function (p) {
    return parseInt(p.theme.SizeBreakpointsS, 10) - 1 + "px";
}, function (p) { return p.theme.SizeWidthModalMobile; }, function (p) { return p.theme.SizePaddingModalMobile; });
var Modal = function (props) {
    var children = props.children, classNameProp = props.className, id = props.id, openProp = props.open, forwardedRef = props.forwardedRef, others = __rest(props, ["children", "className", "id", "open", "forwardedRef"]);
    var isOpen = React.useCallback(function () {
        return openProp;
    }, [openProp]);
    return (isOpen() && (React.createElement(React.Fragment, null,
        React.createElement(BackDrop_1.default, { open: true }),
        React.createElement(ModalSC, __assign({ className: clsx_1.default('_ndsModal', classNameProp), "aria-describedby": id, ref: forwardedRef }, others), children))));
};
exports.ModalRootComp = Modal;
Modal.propTypes = {
    className: prop_types_1.default.string,
    id: prop_types_1.default.string,
    open: prop_types_1.default.bool,
    forwardedRef: prop_types_1.default.any
};
Modal.defaultProps = {
    className: null,
    id: null,
    open: null,
    forwardedRef: null
};
exports.default = reactHelpers_1.withForwardedRef(Modal);
var templateObject_1;
//# sourceMappingURL=Modal.js.map